function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 12"
}, props), React.createElement("path", {
  d: "M16 2H0v-.75C0 .56.45 0 1 0h14c.55 0 1 .56 1 1.25V2zm0 2.5V11a1 1 0 01-1 1H1a1 1 0 01-1-1V4.5h16zM4 8a1 1 0 000 2h1a1 1 0 000-2H4z"
})));